export const state = () => ({
  popUpVisible: false,
  popUpName: null,
  popUpData: null,
  footerVisible: false,
  disableScroll: false,
  hasKeyboard: false,
  hasFooter: false,
  hasNavigation: false,
  hasNotification: false,
  hasNetworkError: false,
  hasAuthenticationError: false,
  networkTries: 0
})

export const mutations = {
  setShowPopup(state, data) {
    if (typeof data === 'object') {
      state.popUpName = data.name
      state.popUpData = data.data
    } else {
      state.popUpName = data
    }
    state.popUpVisible = true
  },
  setHidePopup(state) {
    state.popUpName = null
    state.popUpData = null
    state.popUpVisible = false
  },
  setHasKeyboard(state) {
    state.hasKeyboard = true
  },
  setHasNotKeyboard(state) {
    state.hasKeyboard = false
  },
  setDisableScroll(state, value) {
    state.disableScroll = value
  },
  setHasFooter(state, value) {
    state.hasFooter = value
  },
  setHasNavigation(state, value) {
    state.hasNavigation = value
  },
  setHasNotification(state, value) {
    state.hasNotification = value
  },
  setHasNetworkError(state, value) {
    state.hasNetworkError = value
  },
  setHasAuthenticationError(state, value) {
    state.hasAuthenticationError = value
  },
  incrementNetworkTries(state) {
    state.networkTries++
  },
  resetNetworkTries(state) {
    state.networkTries = 0
  }
}

export const actions = {
  handleNetworkError({ commit }, isError) {
    if (isError) {
      commit('setHasNetworkError', true)
      commit('incrementNetworkTries')
    } else {
      commit('setHasNetworkError', false)
      commit('resetNetworkTries')
    }
  }
}
